import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Security } from '../_models/security';
import { environment } from '../../../environments/environment';

@Injectable()
export class SecurityService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getSecurities(): Observable<Security[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/securities')
      .pipe(map((response) => response));
  }

  getSecurity(id: number): Observable<Security> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/securities/' + id)
      .pipe(map((response) => response));
  }

  saveSecurity(securityItem): Observable<Security> {
    const security = { ...securityItem };
    delete security.lastUpdated;
    delete security.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    security.companyId = companySelected ? companySelected.id : null;

    if (security.user != null && security.user.id != null) {
      security.user = { id: security.user.id };
    }
    if (security.id) {
      return this.http
        .put<Security>(this.apiBaseUrl + 'api/private/v1/securities/' + security.id, security)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Security>(this.apiBaseUrl + 'api/private/v1/securities/', security)
        .pipe(map((response) => response));
    }
  }

  deleteSecurity(id: number): Observable<Security> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/securities/' + id).pipe(
      map((response) => {
        return { id } as Security;
      })
    );
  }
}
